<template>
    <div>
        <el-form ref="editForm" :model="formModel" :rules="rules" class="edit-form" label-width="80px">

            <el-row :gutter="20">

                <el-col :span="24">
                    <el-form-item label="区域" prop="area">
                        <el-input v-model="formModel.area" placeholder="请输入区域"></el-input>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row :gutter="20">

                <el-col :span="24">
                    <el-form-item label="提取链接" prop="url">
                        <!--                        <el-input v-model="formModel.url" placeholder="请输入提取链接"></el-input>-->
                        <el-input v-model="formModel.url" type="textarea" :autosize="{ minRows: 5, maxRows: 10}"
                                  placeholder="请输入提取链接">
                        </el-input>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="备注">
                        <div class="flex">
                            <el-input v-model="formModel.remark" type="textarea" :autosize="{ minRows: 5, maxRows: 10}"
                                      placeholder="请输入备注">
                            </el-input>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item>
                <el-button type="primary" @click="handleSave">保存</el-button>
                <el-button @click="$emit('close')">关闭</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import proxyService from "@/api/order/ProxyService";

export default {
    name: 'ProxyForm',
    props: {
        propFormModel: {
            type: Object
        }
    },
    watch: {
        propFormModel() {
            this.formModel = this.propFormModel
        }
    },
    data() {
        return {
            formModel: this.propFormModel,
            rules: {
                area: [
                    {required: true, message: '请输入区域', trigger: 'change'}
                ],
                url: [
                    {required: true, message: '请输入提取链接', trigger: 'change'}
                ],
            },

        }
    },
    methods: {

        handleSave() {
            this.$refs.editForm.validate((valid) => {
                if (!valid) {
                    return false;
                }

                let promise = null
                if (this.formModel._id) {
                    promise = proxyService.updateById(this.formModel._id, this.formModel)
                } else {
                    promise = proxyService.insert(this.formModel)
                }

                const loading = this.$loading({
                    lock: true,
                    text: '正在保存',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                promise.then(res => {
                    if (!res.success) {
                        this.$message.error(res.message)
                        return
                    }
                    this.$message.success('保存成功')
                    this.formModel._id = res.data
                    this.$emit('refresh')
                }).finally(() => {
                    loading.close()
                })
            });
        }
    },
    created() {

    }
}
</script>


<style scoped lang="scss">
.edit-form .el-date-editor {
    width: 100%;
}
</style>